import styled, { css } from 'styled-components';

const Bullet = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-left: auto;

  ${(prop) => css`
    background: ${prop.color};
  `}
`;

export default Bullet;
